/*
 * ---------------------------------------------------------------------
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 WALC Inc. Inc. All Rights Reserved.
 *
 * file=locale-interceptor.ts
 *
 * This software is the confidential and proprietary information of WALC Inc.
 * (Confidential Information). You shall not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * you entered into with WALC Inc.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * <summary>: すべての HTTP リクエストに表示言語のヘッダー（X-Locale）を付けるインターセプター。
 * ---------------------------------------------------------------------
 */


import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { I18nService } from './i18n.service';
import { LOCALE_HEADER } from './locale';

// fetch で送るリクエスト（会話の SSE、SR 起案の記録）は ChatAgentService が自分で付ける。
export const localeInterceptor: HttpInterceptorFn = (req, next) => {
  const locale = inject(I18nService).locale();
  return next(req.clone({ setHeaders: { [LOCALE_HEADER]: locale } }));
};
